<template>
  <section class="auth wrapper__bg">
    <div class="container">
      <div class="auth__content">
        <div class="auth__colform">
          <div class="auth__nav">
            <a href="https://relaxstation-club.com" class="auth__logo">
              <img src="@/assets/images/logo.svg" alt="" />
            </a>
            <h1 class="auth__caption">{{ $t("auth.sing_in") }}</h1>
          </div>

          <div v-if="message" class="form-error-message">
            {{ message }}
          </div>

          <form
            class="form"
            @submit.prevent="handleSubmit(!v$.$invalid)"
            novalidate
          >
            <div class="form__item">
              <input
                type="text"
                v-model="form.username"
                required=""
                :class="getInputClass(v$.form.username)"
                class="form__input"
              />
              <label for="" class="form__label">
                {{ $t("auth.login") }}
              </label>
              <validate-error
                :field="v$.form.username"
                :submitted="submitted"
              />
            </div>

            <div class="form__item">
              <input
                type="password"
                :class="getInputClass(v$.form.password)"
                v-model="form.password"
                required=""
                class="form__input"
              />
              <label for="" class="form__label">
                {{ $t("auth.password") }}
              </label>
              <validate-error
                :field="v$.form.password"
                :submitted="submitted"
              />
            </div>

            <div class="forgot-item">
              <router-link class="reset" :to="{ name: 'forgot-password' }">
                {{ $t("auth.forgot_password") }}
              </router-link>
            </div>

            <button class="btn-link" type="submit">
              <span class="text">{{ $t("auth.sing_in") }}</span>
              <span class="form__btn">
                <svg>
                  <circle cx="50" cy="50" r="50"></circle>
                </svg>
                <span class="btn-arrow"
                  ><img src="@/assets/images/auth/icon/arrow-gold.svg" alt=""
                /></span>
              </span>
            </button>
            <div class="form__other">
              <span class="form__other-span">
                {{ $t("auth.dont_have_an_account") }}
              </span>

              <router-link class="gold" :to="{ name: 'register' }">
                {{ $t("auth.register") }}
              </router-link>
            </div>
          </form>
        </div>

        <AuthSlider />
      </div>
    </div>
  </section>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { required } from "@/utils/i18n-validators";
import { mapActions, mapGetters } from "vuex";
import AuthSlider from "@/components/profile/AuthSlider";
import ValidateError from "@/components/dumb-components/validateError";
import crudService from "@/services/crudService";

export default {
  name: "LoginPage",
  components: {
    ValidateError,
    AuthSlider,
  },
  setup: () => ({ v$: useVuelidate({ $autoDirty: true }) }),
  data: () => ({
    message: "",
    optMessage: false,
    timerCount: false,
    submitted: false,
    vuelidateExternalResults: [],
    form: {
      username: "",
      password: "",
    },
  }),
  validations() {
    return {
      form: {
        username: { required },
        password: { required },
      },
    };
  },

  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      me: "auth/me",
    }),
    langParam() {
      return this.$route.query._locale;
    },
  },
  methods: {
    ...mapActions({
      login: "auth/login",
    }),
    handleSubmit(isFormValid) {
      this.submitted = true;

      if (!isFormValid) {
        return;
      }

      this.login(this.form).then(
        () => {
          crudService.get("crossAuthUrl").then((res) => {
            window.location.href = res.data.url;
          });
        },
        (fail) => {
          this.message = fail.message;
          Object.assign(this.vuelidateExternalResults, { form: fail.errors });
        }
      );
    },
    getInputClass(field) {
      return field.$invalid && this.submitted ? "invalid" : "";
    },
  },
  created() {
    if (this.isAuthenticated) {
      this.$router.push("/");
    }

    if (this.langParam) {
      this.$i18n.locale = this.langParam;
      localStorage.setItem("lang", this.langParam);
    }
  },
};
</script>

<style scoped lang="scss">
.invalid-feedback {
  display: inherit;
  color: #ff7b7b;
  margin-top: -25px;
  position: absolute;
  font-size: 14px;
}

.form-error-message {
  margin-bottom: 20px;
  color: #ff7b7b;
}
.auth__logo {
  img {
    width: 250px;
  }
}
.forgot-item {
  display: flex;
  justify-content: flex-end;
  .reset {
    color: #bb9e74;
    font-size: 14px;
  }
}
</style>
